export const global = {
    url: 'https://jobtec-inatec.herokuapp.com/api/'
}